// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tcNsK0hVpqnEgsPb7HFM {\n  background-color: var(--main-menu-dark-background);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}", "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACI,kDAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AACJ","sourcesContent":[".sidebar {\n    background-color: var(--main-menu-dark-background);\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": "tcNsK0hVpqnEgsPb7HFM"
};
export default ___CSS_LOADER_EXPORT___;
